import { Component } from '@angular/core';
import { MasterDTO } from '../../model/admin.entity';
import { AdminService } from '../../services/admin.service';
import { CommonService } from '../../../core/common/services/common.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Dropdown } from 'primeng/dropdown';
import { FrameDTO } from '../../model/frame.entity';
import { Router } from '@angular/router';
import { Utility } from '../../../core/common/services/utility.service';

@Component({
  selector: 'tandc-save-frame',
  templateUrl: './save-frame.component.html',
  styleUrls: ['./save-frame.component.scss']
})
export class SaveFrameComponent {
  model: FrameDTO = new FrameDTO();
  modalTitle: string = "";
  frameMaterialList: Dropdown[] = [];
  partnerList: Dropdown[] = [];
  frameList: Dropdown[] = [];
  selectedFrameId?: number;
  addFrame:boolean=false

  constructor(private service: AdminService,
    private commonService: CommonService,
    private utility: Utility,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');

    if (id && Number(id) > 0) {
      this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.frame');
      this.service.getFrameById(Number(id)).subscribe((x) => {
      this.model = x.value;
      if (this.model){
        this.getUnmappedFrame();
        this.getFrameMaterials();
        this.getPartners();
      }
    });
  } 
    else{
      this.modalTitle = this.translate.instant('common.add') + ' ' + this.translate.instant('Master.frame');
      this.addFrame=true;
      this.getUnmappedFrame();
      this.getFrameMaterials();
      this.getPartners();
    }
     
  }
  getUnmappedFrame() {
    if (this.addFrame){
      this.service.getUnmappedFrame().subscribe(x => {
        this.frameList = x.value.map((frame) => ({
          label: frame.name,
          value: frame.id
        }));
      });
    }
  }
getFrameMaterials() {
  this.service.getFrameMaterials().subscribe(x => {
    this.frameMaterialList = x.value;
    this.frameMaterialList = Utility.reorderSelectedOnTop(
      this.frameMaterialList,
      this.model.frameMaterial
    );
  });
}

  getPartners() {
    this.service.getPartners().subscribe(x => {
      this.partnerList = x.value;
      this.partnerList = Utility.reorderSelectedOnTop(
      this.partnerList,
      this.model.partner
    );
    })
  }
  save(data: FrameDTO) {
    if ((!data.id || data.id === 0) && this.selectedFrameId) {
      const selected = this.frameList.find(f => f.value === this.selectedFrameId);
      if (selected) {
        data.id = selected.value;
        data.name = selected.label;
      }
    }
    const cleanData: FrameDTO = {
      id: data.id,
      name: data.name,
      frameMaterial: data.frameMaterial,
      partner: data.partner
    };

    this.service.saveUpdateFrame(cleanData).subscribe(res => {
      if (res) {
        this.commonService.successMessage(
          this.translate.instant('Alerts.UpdatedSuccessfully')

        );
        this.router.navigate(['admin/frame']);
      }
    });
  }



  selectedFrameMaterial(value: any): string | undefined {
  let item = this.frameMaterialList.find(i => i.id === value);
  return item?.name;
  }

  selectedPartner(value: any): string | undefined {
  let item = this.partnerList.find(i => i.id === value);
  return item?.name;
  }



}

